import { createStore, applyMiddleware, Store, StoreEnhancer, compose } from "redux";
import thunkMiddleware, { ThunkDispatch } from "redux-thunk";
import { rootReducer } from "./reducers";
import { flowLogger } from "./middleware/flowLogger";
import { debugLogger } from "./middleware/debugLogger";
import { LogicModel } from "../models/LogicModel";
import * as Evaluator from "../expressions/parser";
import { EvaluationResult } from "../expressions/EvaluationResult";
import { apiConnector } from "./middleware/apiConnector";
import { publicConnector } from "./middleware/publicConnector";
import { ActionTypes } from "./actions/types";
import { StoreState } from "../models/states/StoreState";
import { flowController } from "./middleware/flowController";

const middleware = applyMiddleware(
    thunkMiddleware,
    publicConnector,
    flowController,
    apiConnector,
    flowLogger,
    debugLogger,
);

const composeEnhancers = (window as any).__REDUX_DEVTOOLS_EXTENSION_COMPOSE__ || compose;
const enhancer: StoreEnhancer = composeEnhancers(middleware);

export function configureStore(): Store<StoreState, any> {
    return createStore(rootReducer, enhancer);
}

const store = configureStore();

const dispatch: ThunkDispatch<StoreState, any, ActionTypes> = (action) => store.dispatch(action);

export const __getStore__ = () => store;
export const __dispatch__ = dispatch;

/**
 * @deprecated Use thunk instead.
 * @param logic
 */
export function __evaluate__(logic: LogicModel): EvaluationResult;
export function __evaluate__(logic: string, simple?: boolean): EvaluationResult;
export function __evaluate__(logic: string | LogicModel, simple?: boolean) {
    if (typeof logic === "object")
        return Evaluator.__evaluateUnsafe__(() => store.getState().interview, dispatch, logic);
    return Evaluator.__evaluateUnsafe__(() => store.getState().interview, dispatch, logic, simple);
}
